var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15002_47711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5 0H0.5V42.8787H42.5V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 21C40.5 10.5066 31.9934 2 21.5 2C11.0066 2 2.5 10.5066 2.5 21V21.8787C2.5 32.3721 11.0066 40.8787 21.5 40.8787C31.9934 40.8787 40.5 32.3721 40.5 21.8787V21Z",
    fill: "#ECECEC",
    stroke: "#D08759",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.537 17.6435C27.5135 16.9313 27.0073 16.3545 26.3011 16.2486C23.8645 15.8661 21.216 16.5782 19.1502 18.4027C17.0844 20.2272 16.0603 22.7697 16.1368 25.2358C16.1603 25.9479 16.6665 26.5247 17.3728 26.6306C19.8094 27.0132 22.4578 26.301 24.5236 24.4765C26.5895 22.652 27.6135 20.1095 27.537 17.6435Z",
    fill: "#D08759",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15002_47711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 43,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/userProfile.a65278c89fb00d1d03216c6c1e52a2e3.svg";
export { ForwardRef as ReactComponent };